import { Directive, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { distinctUntilChanged, map } from 'rxjs/operators';

import { FullCandidate } from '@recruitee/candidate-types';
import { DevFlag, injectDevFlag } from '@recruitee/dev-flags-data';

@Directive({
  selector: '[rtKiwiHrIntegrationCardGuard]',
  standalone: true,
})
export class KiwiHrIntegrationCardGuardDirective {
  public candidate = input.required<FullCandidate>({ alias: 'rtKiwiHrIntegrationCardGuard' });

  public hasTransferCandidateToKiwi = injectDevFlag(DevFlag.TransferCandidateToKiwi);

  constructor(
    private vcRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    toObservable(this.candidate)
      .pipe(
        map(candidate => this.isCandidateHired(candidate)),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe(isHired => {
        if (isHired && this.hasTransferCandidateToKiwi) {
          this.vcRef.createEmbeddedView(this.templateRef);
        } else {
          this.vcRef.clear();
        }
      });
  }

  private isCandidateHired(candidate: FullCandidate): boolean {
    return candidate.placements.some(placement => placement.hiredInThisPlacement);
  }
}
